export default __webpack_public_path__ + "static/media/_enmasjid-avatar-web.3ad7112c.jpg";